import {FormControl, FormGroup, ValidatorFn} from '@angular/forms';

export class ValidationHelper {

  public static noWhitespaceValidator(control: FormControl): null | object {
    const isWhitespace = control.value?.length && (control.value || '').trim().length === 0;
    const isValid = !isWhitespace;

    return isValid ? null : {whitespace: true};
  }

  public static minLengthValidator(control: FormControl): null | object {
    const isMinlength = control.value?.length && control.value.trim().length < 2;
    const isValid = !isMinlength;

    return isValid ? null : {minLength: true};
  }

  public static checkPasswords(group: FormGroup): null | object {
    const password = group.get('password');
    const confirmPassword = group.get('confirm_password');

    if (password.value === confirmPassword.value) {
      if (confirmPassword.errors && !confirmPassword.errors.hasOwnProperty('required')) {
        confirmPassword.setErrors(null);
      }
      return null;
    } else {
      confirmPassword.setErrors({notSame: true});
      return {notSame: true};
    }
  }

  public static checkStringNull(value: string): string {
    if (value && value === 'null') {
      value = null;
    }
    return value;
  }

  public static patternValidator(pattern: string | RegExp): ValidatorFn {
    const regex = new RegExp(pattern);

    return (control: FormControl) => {
      const value = `${control.value}`;
      if (value && !regex.test(value)) {
        return {
          pattern: {
            requiredPattern: pattern,
            actualValue: control.value,
          },
        };
      }

      return null;
    };
  }
}

